var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33337 4.83325H11C11.3667 4.83325 11.6667 5.13325 11.6667 5.49992V10.1666C11.6667 10.5333 11.3667 10.8333 11 10.8333H6.33337C5.96671 10.8333 5.66671 10.5333 5.66671 10.1666V5.49992C5.66671 5.13325 5.96671 4.83325 6.33337 4.83325ZM4.33337 6.49992C4.33337 6.31659 4.48337 6.16659 4.66671 6.16659C4.85004 6.16659 5.00004 6.31659 5.00004 6.49992V11.1666C5.00004 11.3499 5.15004 11.4999 5.33337 11.4999H10C10.1834 11.4999 10.3334 11.6499 10.3334 11.8333C10.3334 12.0166 10.1834 12.1666 10 12.1666H5.00004C4.63337 12.1666 4.33337 11.8666 4.33337 11.4999V6.49992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.fe91a772abb07413e87a98a060650abe.svg";
export { ForwardRef as ReactComponent };